import {
  AnnotateSVG,
  GuidedHighlightingSVG,
  ImageCaptureSVG,
  QuizSVG,
} from "@newsela/angelou";
import { objectTypes } from "@newsela/snitch";

import AssignmentsCompleteIcon from "@/icons/AssignmentsCompleteIcon";
import BoltIcon from "@/icons/BoltIcon";
import QuizIcon from "@/icons/QuizIcon";
import WritePromptIcon from "@/icons/WritePromptIcon";

const activityTypes = {
  QUIZ: {
    icon: QuizIcon,
    label: "Quiz",
    objectType: objectTypes.quiz,
  },
  WRITE_PROMPT: {
    icon: WritePromptIcon,
    label: "Write prompt",
    objectType: objectTypes.writePrompt,
  },
  ANNOTATIONS: {
    icon: AnnotateSVG,
    label: "Annotations",
    objectType: "Annotations",
  },
  POWER_WORDS_ACTIVITY: {
    icon: BoltIcon,
    label: "Power Words",
    objectType: objectTypes.articleWord,
  },
  GRADING_ACTIVITY: {
    icon: AssignmentsCompleteIcon,
    label: "Review student work",
  },
  GUIDED_HIGHLIGHTING_QUIZ: {
    icon: GuidedHighlightingSVG,
    label: "Guided Highlighting",
    objectType: "GUIDED_HIGHLIGHTING_QUIZ",
  },
  CHECKS_FOR_UNDERSTANDING_QUIZ: {
    icon: QuizSVG,
    label: "Checks for understanding",
  },
  GRAPHIC_ORGANIZERS: {
    icon: ImageCaptureSVG, // TODO: replace with graphic organizers icon
    label: "Graphic Organizers",
  },
};

export default activityTypes;
